// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

let baseStyles = Emotion.Css.css({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  minWidth: "0",
  wordWrap: "break-word",
  borderRadius: Emotion.Utils.Border.getRadius("sm"),
  transition: Emotion.Utils.Animate.getDuration("fast") + " ease-out"
});

function getVariantStyles(variant) {
  if (variant === "outlined") {
    return Emotion.Css.css({
      backgroundColor: Emotion.Utils.Color.bgPrimary,
      border: `1px solid ` + Emotion.Utils.Color.border,
      boxShadow: "none"
    });
  } else if (variant === "elevated") {
    return Emotion.Css.css({
      backgroundColor: Emotion.Utils.Color.bgElevated,
      boxShadow: Emotion.Utils.Shadow.getShadow("md"),
      border: `1px solid ` + Emotion.Utils.Color.border
    });
  } else {
    return Emotion.Css.css({
      backgroundColor: Emotion.Utils.Color.bgElevated,
      border: "1px solid transparent",
      boxShadow: "none"
    });
  }
}

function getSizeStyles(size) {
  if (size === "md") {
    return Emotion.Css.css({
      maxWidth: "24rem"
    });
  } else if (size === "sm") {
    return Emotion.Css.css({
      maxWidth: "20rem"
    });
  } else {
    return Emotion.Css.css({
      maxWidth: "32rem"
    });
  }
}

function getPaddingStyles(padding) {
  if (padding === "lg") {
    return Emotion.Css.css({
      padding: Emotion.Utils.Space.getSpacing("6")
    });
  } else if (padding === "md") {
    return Emotion.Css.css({
      padding: Emotion.Utils.Space.getSpacing("4")
    });
  } else if (padding === "sm") {
    return Emotion.Css.css({
      padding: Emotion.Utils.Space.getSpacing("3")
    });
  } else {
    return Emotion.Css.css({
      padding: "0"
    });
  }
}

function getInteractiveStyles() {
  return Emotion.Css.css({
    cursor: "pointer",
    ":hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)"
    }
  });
}

function Card$Card(props) {
  let __className = props.className;
  let __interactive = props.interactive;
  let __padding = props.padding;
  let size = props.size;
  let __variant = props.variant;
  let variant = __variant !== undefined ? __variant : "elevated";
  let padding = __padding !== undefined ? __padding : "md";
  let interactive = __interactive !== undefined ? __interactive : false;
  let className = __className !== undefined ? __className : "";
  let cardClassName = Emotion.Css.cx([
    baseStyles,
    getVariantStyles(variant),
    getPaddingStyles(padding),
    interactive ? getInteractiveStyles() : "",
    size !== undefined ? getSizeStyles(size) : "",
    className
  ]);
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: cardClassName,
    onClick: props.onClick
  });
}

function Card$Card$Header(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let headerClassName = Emotion.Css.cx([
    Emotion.Css.css({
      padding: Emotion.Utils.Space.getSpacing("4"),
      paddingBottom: Emotion.Utils.Space.getSpacing("2"),
      borderBottom: `1px solid ` + Emotion.Utils.Color.border
    }),
    className
  ]);
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: headerClassName
  });
}

let Header = {
  make: Card$Card$Header
};

function Card$Card$Body(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let bodyClassName = Emotion.Css.cx([
    Emotion.Css.css({
      padding: Emotion.Utils.Space.getSpacing("4"),
      flex: "1"
    }),
    className
  ]);
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: bodyClassName
  });
}

let Body = {
  make: Card$Card$Body
};

function Card$Card$Footer(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let footerClassName = Emotion.Css.cx([
    Emotion.Css.css({
      padding: Emotion.Utils.Space.getSpacing("4"),
      paddingTop: Emotion.Utils.Space.getSpacing("2"),
      borderTop: `1px solid ` + Emotion.Utils.Color.border,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end"
    }),
    className
  ]);
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: footerClassName
  });
}

let Footer = {
  make: Card$Card$Footer
};

let Card = {
  baseStyles: baseStyles,
  getVariantStyles: getVariantStyles,
  getSizeStyles: getSizeStyles,
  getPaddingStyles: getPaddingStyles,
  getInteractiveStyles: getInteractiveStyles,
  make: Card$Card,
  Header: Header,
  Body: Body,
  Footer: Footer
};

export {
  Card,
}
/* baseStyles Not a pure module */
